import React, { useState, useEffect } from 'react';
import './Hero.css';
import backgroundImage from '../assets/basketball-bg.jpg';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div 
      className="hero" 
      style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${backgroundImage})` }}
    >
      <div className="hero-content">
        <h1 className={`hero-title ${isVisible ? 'animate-fadeInUp' : ''}`}>
          BASKETBALL
          <br />
          CULTURE
        </h1>
        <div className={`hero-subtitle ${isVisible ? 'animate-fadeInUp stagger-delay-1' : ''}`}>
          THE PODCAST THAT INSPIRES CHANGE
        </div>
      </div>
    </div>
  );
};

export default Hero;

